export enum SituacaoEmailAlterado {
  Aberto = 'Aberto',
  Cancelado = 'Cancelado',
  Expirado = 'Expirado',
  Finalizado = 'Finalizado'
}
